<template>
  <div>
    <div v-if="loading" class="loading-bar">
      <atom-spinner
        :animation-duration="1000"
        :size="60"
        color="#ff1d5e"
        class="mx-auto"
      />
    </div>
    <div class="vx-row">
      <vx-card>
        <vs-table
          @selected="handleSelected"
          :max-items="paginationItems[1]"
          pagination
          :data="userData"
          :description="false"
          search
          :description-items="paginationItems"
          description-title="Registries"
          description-connector="of"
          description-body="Pages"
        >
          <template slot="header">
            <div class="list-heading">
              {{ $t("system.label.users") }}
            </div>
            <div class="mr-2 mb-1 order-1">
              <vs-button
                icon-pack="feather"
                icon="icon-plus"
                @click="$router.push({ name: `Create User` })"
                size="small"
                >{{ $t("system.label.createUser") }}</vs-button
              >
            </div>
          </template>
          <template slot="thead">
            <vs-th>{{ $t("system.label.userName") }}</vs-th>
            <vs-th>{{ $t("system.label.firstName") }}</vs-th>
            <vs-th>{{ $t("system.label.lastName") }}</vs-th>
            <vs-th>{{ $t("system.label.email") }}</vs-th>
            <vs-th>{{ $t("system.label.assignedRoles") }}</vs-th>
            <vs-th class="tHeadCenter">{{ $t("system.label.action") }}</vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr
              :key="index"
              :data="userData"
              v-for="(userData, index) in data"
            >
              <vs-td :data="userData.username">{{ userData.username }}</vs-td>
              <vs-td :data="userData.firstname">{{ userData.firstname }}</vs-td>
              <vs-td :data="userData.lastname">{{ userData.lastname }}</vs-td>
              <vs-td :data="userData.email">{{ userData.email }}</vs-td>
              <vs-td :data="userData.officeName">{{
                userData.selectedRoles.map(role => role.name).join(', ')
              }}</vs-td>

              <vs-td class="whitespace-no-wrap">
                <div class="container_img">
                  <feather-icon
                    icon="EditIcon"
                    title="Edit"
                    svgClasses="w-5 h-5 stroke-current cursor orange_icon"
                    @click.stop="editUserData(userData.id)"
                    class="icon_row"
                  />
                  <feather-icon
                    icon="TrashIcon"
                    title="Delete"
                    svgClasses="w-5 h-5 text-danger stroke-current cursor"
                    @click.stop="
                      deletePopup = true;
                      delId = userData.id;
                    "
                    class="icon_row"
                  />
                  <feather-icon
                    icon="LockIcon"
                    title="Change Password"
                    svgClasses="w-5 h-5 hover:text-warning stroke-current cursor"
                    class="icon_row"
                    @click.stop="
                      userChangePassword = true;
                      passwordId = userData.id;
                    "
                  />
                </div>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </vx-card>
    </div>
    <div class="centerx">
      <vs-popup
        classContent="popup-example"
        :title="$t('system.label.deleteUser')"
        :active.sync="deletePopup"
        class="popup-close small-popup"
      >
        <div class="center">
          <img src="@/assets/images/pages/delete.svg" />
          <div class="success-msg">
            {{ $t("system.label.areYouSureDelete") }}
          </div>
        </div>

        <div class="center">
          <span class="p-2">
            <vs-button type="border" @click="deletePopup = false">{{
              $t("system.label.cancel")
            }}</vs-button></span
          >

          <span class="p-2">
            <vs-button @click="deleteUser(delId)">{{
              $t("system.label.confirm")
            }}</vs-button>
          </span>
        </div>
        <div style="height: 20px"></div>
      </vs-popup>
    </div>
    <!-- settings change password popup -->
    <div>
      <ValidationObserver ref="observer">
        <div class="centerx">
          <vs-popup
            classContent="popup-example"
            :title="$t('system.label.changePassword')"
            :active.sync="userChangePassword"
            class="popup-close"
          >
            <form>
              <div class="vx-row md:w-full lg:w-full sm:w-full mb-6">
                <div
                  class="relative w-full"
                  v-if="!changePassword.sendPasswordToEmail"
                >
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    name="password"
                  >
                    <div class="password-container">
                      <vs-input
                        :label="$t('system.label.password')"
                        class="w-full mb-3 ml-5 font-semibold starlabel"
                        :type="passwordFieldType"
                        v-model="changePassword.password"
                        @input="checkPasswordStrength"
                      />
                      <button
                        v-if="changePassword.password"
                        type="button"
                        class="absolute right-0 pr-3 flex items-center eye-btn"
                        @click="togglePasswordVisibility"
                      >
                        <span v-if="isPasswordVisible">
                          <i
                            style="top: -35px; right: 16px"
                            class="vs-icon notranslate icon-scale icon-inputx notranslate vs-input--icon material-icons null icon-after cursor-pointer"
                            >icon iconvisibility_off</i
                          ></span
                        >
                        <span v-else>
                          <i
                            style="top: -35px; right: 16px"
                            class="vs-icon notranslate icon-scale icon-inputx notranslate vs-input--icon material-icons null icon-after cursor-pointer"
                            >icon iconvisibility</i
                          >
                        </span>
                      </button>
                    </div>
                    <span
                      class="validate-error"
                      style="color: red; margin-left: 20px"
                      >{{ errors[0] }}</span
                    >
                  </ValidationProvider>
                  <small
                    v-if="changePassword.password && passwordStrength"
                    style="margin-left: 20px"
                  >
                    Password Strength:
                    <small :class="passwordStrengthClass">
                      {{ passwordStrength }}
                    </small>
                  </small>
                </div>
                <div
                  v-if="!changePassword.sendPasswordToEmail"
                  class="relative w-full"
                >
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    name="repeat password"
                  >
                    <div class="password-container">
                      <vs-input
                        :label="$t('system.label.repeatPassword')"
                        class="w-full mb-3 ml-5 font-semibold starlabel"
                        :type="repeatPasswordFieldType"
                        v-model="changePassword.repeatPassword"
                      />
                      <button
                        v-if="changePassword.repeatPassword"
                        type="button"
                        class="absolute right-0 pr-3 flex items-center eye-btn"
                        @click="toggleRepeatPasswordVisibility"
                      >
                        <span v-if="isRepeatPasswordVisible"
                          ><i
                            style="top: -35px; right: 16px"
                            class="vs-icon notranslate icon-scale icon-inputx notranslate vs-input--icon material-icons null icon-after cursor-pointer"
                            >icon iconvisibility_off</i
                          ></span
                        >
                        <span v-else>
                          <i
                            style="top: -35px; right: 16px"
                            class="vs-icon notranslate icon-scale icon-inputx notranslate vs-input--icon material-icons null icon-after cursor-pointer"
                            >icon iconvisibility</i
                          ></span
                        >
                      </button>
                    </div>
                    <span
                      class="validate-error"
                      style="color: red; margin-left: 20px"
                      >{{ errors[0] }}</span
                    >
                  </ValidationProvider>
                  <small
                    v-if="passwordMismatch"
                    class="text-red-500"
                    style="color: red; margin-left: 20px"
                  >
                    {{ $t("Password not matched") }}
                  </small>
                </div>
              </div>

              <div
                class="vx-row"
                style="display: flex; justify-content: center"
              >
                <span class="ml-4 mr-1">
                  <vs-button
                    type="border"
                    @click="userChangePassword = false"
                    >{{ $t("system.label.cancel") }}</vs-button
                  >
                </span>
                <span class="ml-1 mr-2">
                  <vs-button
                    icon-pack="feather"
                    icon="icon-check"
                    @click="savePasswordChange(passwordId)"
                    >{{ $t("system.label.submit") }}</vs-button
                  >
                </span>
              </div>
            </form>
          </vs-popup>
        </div>
      </ValidationObserver>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { AtomSpinner } from "epic-spinners";
import { ValidationProvider, ValidationObserver } from "vee-validate";

const changepassObj = {
  sendPasswordToEmail: false,
  password: "",
  repeatPassword: "",
};
export default {
  data() {
    return {
      loading: false,
      paginationItems: [5, 10, 15],
      deletePopup: false,
      delId: 0,
      passwordId: 0,
      userChangePassword: false,
      changePassword: changepassObj,
      isPasswordVisible: false,
      isRepeatPasswordVisible: false,
      passwordStrengthClass: "",
      passwordStrength: "",
    };
  },
  components: {
    AtomSpinner,
    ValidationProvider,
    ValidationObserver,
  },
  computed: {
    ...mapGetters({
      userData: "users/getUsersList",
    }),
    passwordFieldType() {
      return this.isPasswordVisible ? "text" : "password";
    },
    repeatPasswordFieldType() {
      return this.isRepeatPasswordVisible ? "text" : "password";
    },

    passwordMismatch() {
      if (!this.changePassword.sendPasswordToEmail) {
        return (
          this.changePassword.password &&
          this.changePassword.repeatPassword &&
          this.changePassword.password !== this.changePassword.repeatPassword
        );
      } else return false;
    },
  },
  methods: {
    togglePasswordVisibility() {
      this.isPasswordVisible = !this.isPasswordVisible;
    },
    toggleRepeatPasswordVisibility() {
      this.isRepeatPasswordVisible = !this.isRepeatPasswordVisible;
    },
    checkPasswordStrength(val) {
      console.log(val);
      const password = val;
      const hasNumber = /[0-9]/;
      const hasUppercase = /[A-Z]/;
      const hasSpecial = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/;
      const minLength = 8;
      const isStrong =
        password.length >= minLength &&
        hasNumber.test(password) &&
        hasUppercase.test(password) &&
        hasSpecial.test(password);
      if (isStrong) {
        this.passwordStrength = "Strong";
        this.passwordStrengthClass = "text-green-500";
        return;
      }
      console.log(
        "Password is not strong enough.",
        hasSpecial.test(password),
        hasUppercase.test(password),
        hasNumber.test(password)
      );
      const isMedium =
        password.length >= minLength &&
        hasNumber.test(password) &&
        hasUppercase.test(password);

      if (isMedium) {
        this.passwordStrength = "Medium";
        this.passwordStrengthClass = "text-yellow-500";
        return;
      }
      const isWeak = password.length <= minLength;
      if (isWeak) {
        this.passwordStrength = "Weak";
        this.passwordStrengthClass = "text-red-500";
        return;
      }
      return "Password must be at least 8 characters long, contain atleat one special character, one capital letter, and one number.";
    },
    handleSelected(userData) {
      this.$router
        .push({ name: `View User`, params: { id: userData.id } })
        .catch(() => {});
    },
    async deleteUser(id) {
      try {
        this.deletePopup = false;
        await this.$store.dispatch("users/deleteUserDataAction", id);
        await this.getUserList();
        this.$swal({
          title: "Success",
          icon: "success",
          text: "User Deleted Successfully!",
          type: "success",
        });
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async getUserList() {
      this.loading = true;
      try {
        await this.$store.dispatch("users/setUsersList");
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
      this.loading = false;
    },

    editUserData(id) {
      this.$router.push({ name: `Edit User Data`, params: { id: id } });
    },
    async savePasswordChange(id) {
      const isValid = await this.$refs.observer.validate();
      if (!isValid || this.passwordMismatch) {
        return;
      }
      try {
        const payload = {
          id: id,
          data: this.changePassword,
        };
        const resp = await this.$store.dispatch(
          "users/editRoleAction",
          payload
        );
        if (resp.status == 200) {
          this.getUserList();
          this.userChangePassword = false;
          this.resetForm();
        }
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Change Password Successfully!",
          type: "success",
        });
      } catch (e) {
        this.userChangePassword = false;
        const errorMessage = String(e).replace(/^Error:\s*/, "");
        await this.$swal({
          title: "Error",
          icon: "error",
          html: `<div style="text-align: center;">${errorMessage}</div>`,
          type: "error",
        });
        this.userChangePassword = true;
      }
    },
    resetForm() {
      (this.changePassword.password = ""),
        (this.changePassword.repeatPassword = "");
    },
  },
  mounted() {
    this.getUserList();
  },
};
</script>
<style lang="scss" scoped>
.vs-table--search {
  max-width: 100%;
  margin-left: 0px !important;
}

.vuesax-app-is-ltr .vs-table--search {
  margin-left: 0;
}

.vs-search-categeory {
  margin-top: 17px;
}
.text-red-500 {
  color: rgb(211, 31, 31);
}
.text-yellow-500 {
  color: rgb(208, 200, 45);
}
.text-green-500 {
  color: rgb(44, 170, 44);
}
</style>
